import { Formik, Form, ErrorMessage } from "formik";
import CustomField from "./CustomField";


const RangeField = ({ field, values }) => {
  const value = values[field.name] || 50;

  return (
    <div className="w-full max-w-md p-4">
      <div className="space-y-4">
        <div className="flex justify-between items-center">
          <span className="text-gray-500 text-sm">{field.label}</span>
        </div>
        <div className="relative pt-4">
          <div className="h-2 rounded-full bg-gray-200 overflow-hidden flex">
            <div
              className="bg-[#F4A460] border-r-4 border-white transition-all duration-200"
              style={{ width: `${value}%` }}
            />
          </div>
          <div
            className="absolute top-0 transform -translate-y-full transition-all duration-200"
            style={{ left: `${value}%` }}
          >
            <div className="relative -translate-x-1/2">
              <div className="w-8 h-8 rounded-full bg-[#483D8B] flex items-center justify-center">
                <span className="text-white text-xs font-medium">{value}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const  ViewComponent = ({ fields, initialValues, }) => (
  <Formik initialValues={initialValues}>
    {({ values}) => (

      <Form className="space-y-6 bg-white p-4 rounded-lg">

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3.2">
          {fields.map((field, index) => (
            <div key={index} className="space-y-2">
              {field.type === "range" ? (
                <RangeField field={field} values={values} />
              ) : (
                <>
                  <label
                    htmlFor={field.name}
                    className="block text-sm font-medium text-gray-700"
                  >
                   
                    {field?.hidden == false ? field.label : ''}
                  </label>
                  {field?.hidden == false ?
                    <CustomField
                      field={field}
                      values={values}
              
                    /> : ''}

                  {/* <ErrorMessage
                    name={field.name}
                    component="div"
                    className="text-red-500 !mt-1.5 text-base"
                  /> */}
                </>
              )}
            </div>
          ))}
        </div>
      </Form>
    )}
  </Formik>
);

export default ViewComponent;
